<template>
  <svg class="SVG-Star" :class="{ 'disable-hover': color }" :width="size" :height="size" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :fill="computedFillColor" d="M11.9908 5.30515C12.0507 4.99072 11.8109 4.6134 11.5111 4.6134L8.09376 4.1103L6.53496 0.840189C6.47501 0.714415 6.41505 0.651528 6.29514 0.588641C5.99538 0.399981 5.63565 0.525755 5.45579 0.840189L3.95695 4.1103L0.539584 4.6134C0.359723 4.6134 0.239815 4.67628 0.179861 4.80206C-0.0599538 5.0536 -0.0599538 5.43092 0.179861 5.68247L2.63797 8.19794L2.03843 11.7825C2.03843 11.9083 2.03843 12.034 2.09838 12.1598C2.27824 12.4742 2.63797 12.6 2.93773 12.4114L5.99538 10.7134L9.05302 12.4114C9.11297 12.4742 9.23288 12.4742 9.35279 12.4742C9.41274 12.4742 9.41274 12.4742 9.47269 12.4742C9.77246 12.4114 10.0123 12.0969 9.95232 11.7196L9.35279 8.13506L11.8109 5.61959C11.9308 5.5567 11.9908 5.43093 11.9908 5.30515Z" />
  </svg>
</template>

<script setup>
  import {computed} from "vue";

  const props = defineProps({
    size: { type: Number, default: 12 },
    //Активна ли звездочка
    isActive: { type: Boolean, default: false },
    //Статичный цвет
    color:{ type: String, default: ''},
    //Цвета для звездочки в динамике
    colors: { 
      type: Object,
      default: () => ({
        active: 'var(--yellow-500)',
        disable: 'var(--gray-300)'
      }),
      validator(value) {
        const requiredKeys = ['active', 'disable'];
        const keysPresent = Object.keys(value);
        const isValid = requiredKeys.every(key => keysPresent.includes(key));

        if (!isValid) {
          console.warn(`Invalid keys in colors prop. Expected keys: ${requiredKeys.join(', ')}, but got: ${keysPresent.join(', ')}.`);
        }

        return isValid;
      }
    }
  });

  // Вычисляем цвет для заливки
  const computedFillColor = computed(() => {
    // Если передан цвет, используем его
    if (props.color) {
      return props.color;
    }
    // Если нет, используем логический цвет из объекта colors
    return props.isActive ? props.colors.active : props.colors.disable;
  });
</script>

<style lang="scss">
  .SVG-Star{
    transition: fill 0.3s ease;

    &:not(.disable-hover):hover path{
      fill: var(--yellow-400);
    }
  }
</style>
